var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 23.9403H33.6262V26.3149H36.0008V23.9403Z",
    fill: "#470F17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 21.5581H33.6262V23.9403H36.0008V21.5581Z",
    fill: "#470F17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 19.1835H33.6262V21.5581H36.0008V19.1835Z",
    fill: "#470F17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 16.8088H33.6262V19.1834H36.0008V16.8088Z",
    fill: "#470F17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 14.4343H33.6262V16.8089H36.0008V14.4343Z",
    fill: "#470F17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0008 4.93677H33.6262V7.31137H36.0008V4.93677Z",
    fill: "#470F17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 28.6896H31.2512V31.0642H33.6258V28.6896Z",
    fill: "#470F17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 26.3149H31.2512V28.6895H33.6258V26.3149Z",
    fill: "#470F17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 23.9403H31.2512V26.3149H33.6258V23.9403Z",
    fill: "#96050A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 21.5581H31.2512V23.9403H33.6258V21.5581Z",
    fill: "#96050A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 19.1835H31.2512V21.5581H33.6258V19.1835Z",
    fill: "#96050A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 16.8088H31.2512V19.1834H33.6258V16.8088Z",
    fill: "#96050A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 14.4343H31.2512V16.8089H33.6258V14.4343Z",
    fill: "#96050A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 12.0597H31.2512V14.4343H33.6258V12.0597Z",
    fill: "#470F17"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 7.31128H31.2512V9.68589H33.6258V7.31128Z",
    fill: "#470F17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 4.93677H31.2512V7.31137H33.6258V4.93677Z",
    fill: "#24A869"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6258 2.56201H31.2512V4.93662H33.6258V2.56201Z",
    fill: "#470F17"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 31.0641H28.8774V33.4387H31.252V31.0641Z",
    fill: "#470F17"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 28.6896H28.8774V31.0642H31.252V28.6896Z",
    fill: "#96050A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 26.3149H28.8774V28.6895H31.252V26.3149Z",
    fill: "#96050A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 23.9403H28.8774V26.3149H31.252V23.9403Z",
    fill: "#BD0304"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 21.5581H28.8774V23.9403H31.252V21.5581Z",
    fill: "#BD0304"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 19.1835H28.8774V21.5581H31.252V19.1835Z",
    fill: "#BD0304"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 16.8088H28.8774V19.1834H31.252V16.8088Z",
    fill: "#BD0304"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 14.4343H28.8774V16.8089H31.252V14.4343Z",
    fill: "#BD0304"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 12.0597H28.8774V14.4343H31.252V12.0597Z",
    fill: "#96050A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 9.68591H28.8774V12.0605H31.252V9.68591Z",
    fill: "#470F17"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 7.31128H28.8774V9.68589H31.252V7.31128Z",
    fill: "#470F17"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 4.93677H28.8774V7.31137H31.252V4.93677Z",
    fill: "#168E52"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.252 2.56201H28.8774V4.93662H31.252V2.56201Z",
    fill: "#470F17"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 33.4388H26.5024V35.8134H28.877V33.4388Z",
    fill: "#470F17"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 31.0641H26.5024V33.4387H28.877V31.0641Z",
    fill: "#96050A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 28.6896H26.5024V31.0642H28.877V28.6896Z",
    fill: "#96050A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 26.3149H26.5024V28.6895H28.877V26.3149Z",
    fill: "#BD0304"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 23.9403H26.5024V26.3149H28.877V23.9403Z",
    fill: "#BD0304"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 21.5581H26.5024V23.9403H28.877V21.5581Z",
    fill: "#BD0304"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 19.1835H26.5024V21.5581H28.877V19.1835Z",
    fill: "#BD0304"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 16.8088H26.5024V19.1834H28.877V16.8088Z",
    fill: "#BD0304"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 14.4343H26.5024V16.8089H28.877V14.4343Z",
    fill: "#BD0304"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 12.0597H26.5024V14.4343H28.877V12.0597Z",
    fill: "#BD0304"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 9.68591H26.5024V12.0605H28.877V9.68591Z",
    fill: "#96050A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 7.31128H26.5024V9.68589H28.877V7.31128Z",
    fill: "#470F17"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 4.93677H26.5024V7.31137H28.877V4.93677Z",
    fill: "#168E52"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 2.56201H26.5024V4.93662H28.877V2.56201Z",
    fill: "#24A869"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.877 0.1875H26.5024V2.56211H28.877V0.1875Z",
    fill: "#470F17"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 33.4388H24.1274V35.8134H26.502V33.4388Z",
    fill: "#470F17"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 31.0641H24.1274V33.4387H26.502V31.0641Z",
    fill: "#96050A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 28.6896H24.1274V31.0642H26.502V28.6896Z",
    fill: "#BD0304"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 26.3149H24.1274V28.6895H26.502V26.3149Z",
    fill: "#BD0304"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 23.9403H24.1274V26.3149H26.502V23.9403Z",
    fill: "#BD0304"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 21.5581H24.1274V23.9403H26.502V21.5581Z",
    fill: "#BD0304"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 19.1835H24.1274V21.5581H26.502V19.1835Z",
    fill: "#BD0304"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 16.8088H24.1274V19.1834H26.502V16.8088Z",
    fill: "#BD0304"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 14.4343H24.1274V16.8089H26.502V14.4343Z",
    fill: "#BD0304"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 12.0597H24.1274V14.4343H26.502V12.0597Z",
    fill: "#BD0304"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 9.68591H24.1274V12.0605H26.502V9.68591Z",
    fill: "#96050A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 7.31128H24.1274V9.68589H26.502V7.31128Z",
    fill: "#470F17"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 4.93677H24.1274V7.31137H26.502V4.93677Z",
    fill: "#168E52"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 2.56201H24.1274V4.93662H26.502V2.56201Z",
    fill: "#24A869"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M26.502 0.1875H24.1274V2.56211H26.502V0.1875Z",
    fill: "#470F17"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 35.8125H21.7534V38.1871H24.128V35.8125Z",
    fill: "#470F17"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 33.4388H21.7534V35.8134H24.128V33.4388Z",
    fill: "#96050A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 31.0641H21.7534V33.4387H24.128V31.0641Z",
    fill: "#BD0304"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 28.6896H21.7534V31.0642H24.128V28.6896Z",
    fill: "#BD0304"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 26.3149H21.7534V28.6895H24.128V26.3149Z",
    fill: "#F20000"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 23.9403H21.7534V26.3149H24.128V23.9403Z",
    fill: "#F20000"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 21.5581H21.7534V23.9403H24.128V21.5581Z",
    fill: "#F20000"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 19.1835H21.7534V21.5581H24.128V19.1835Z",
    fill: "#F20000"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 16.8088H21.7534V19.1834H24.128V16.8088Z",
    fill: "#F20000"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 14.4343H21.7534V16.8089H24.128V14.4343Z",
    fill: "#BD0304"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 12.0597H21.7534V14.4343H24.128V12.0597Z",
    fill: "#BD0304"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 9.68591H21.7534V12.0605H24.128V9.68591Z",
    fill: "#96050A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 7.31128H21.7534V9.68589H24.128V7.31128Z",
    fill: "#470F17"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 4.93677H21.7534V7.31137H24.128V4.93677Z",
    fill: "#168E52"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 2.56201H21.7534V4.93662H24.128V2.56201Z",
    fill: "#24A869"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M24.128 0.1875H21.7534V2.56211H24.128V0.1875Z",
    fill: "#470F17"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 35.8125H19.3784V38.1871H21.753V35.8125Z",
    fill: "#470F17"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 33.4388H19.3784V35.8134H21.753V33.4388Z",
    fill: "#96050A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 31.0641H19.3784V33.4387H21.753V31.0641Z",
    fill: "#BD0304"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 28.6896H19.3784V31.0642H21.753V28.6896Z",
    fill: "#F20000"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 26.3149H19.3784V28.6895H21.753V26.3149Z",
    fill: "#F20000"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 23.9403H19.3784V26.3149H21.753V23.9403Z",
    fill: "#F20000"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 21.5581H19.3784V23.9403H21.753V21.5581Z",
    fill: "#F20000"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 19.1835H19.3784V21.5581H21.753V19.1835Z",
    fill: "#F20000"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 16.8088H19.3784V19.1834H21.753V16.8088Z",
    fill: "#F20000"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 14.4343H19.3784V16.8089H21.753V14.4343Z",
    fill: "#F20000"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 12.0597H19.3784V14.4343H21.753V12.0597Z",
    fill: "#BD0304"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 9.68591H19.3784V12.0605H21.753V9.68591Z",
    fill: "#470F17"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 7.31128H19.3784V9.68589H21.753V7.31128Z",
    fill: "#470F17"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 4.93677H19.3784V7.31137H21.753V4.93677Z",
    fill: "#168E52"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21.753 2.56201H19.3784V4.93662H21.753V2.56201Z",
    fill: "#470F17"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 35.8125H17.0034V38.1871H19.378V35.8125Z",
    fill: "#470F17"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 33.4388H17.0034V35.8134H19.378V33.4388Z",
    fill: "#96050A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 31.0641H17.0034V33.4387H19.378V31.0641Z",
    fill: "#BD0304"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 28.6896H17.0034V31.0642H19.378V28.6896Z",
    fill: "#F20000"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 26.3149H17.0034V28.6895H19.378V26.3149Z",
    fill: "#F20000"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 23.9403H17.0034V26.3149H19.378V23.9403Z",
    fill: "#F20000"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 21.5581H17.0034V23.9403H19.378V21.5581Z",
    fill: "#F20000"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 19.1835H17.0034V21.5581H19.378V19.1835Z",
    fill: "#F20000"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 16.8088H17.0034V19.1834H19.378V16.8088Z",
    fill: "#F20000"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 14.4343H17.0034V16.8089H19.378V14.4343Z",
    fill: "#F20000"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 12.0597H17.0034V14.4343H19.378V12.0597Z",
    fill: "#96050A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 9.68591H17.0034V12.0605H19.378V9.68591Z",
    fill: "#470F17"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 7.31128H17.0034V9.68589H19.378V7.31128Z",
    fill: "#470F17"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M19.378 4.93677H17.0034V7.31137H19.378V4.93677Z",
    fill: "#470F17"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 35.8125H14.6309V38.1871H17.0055V35.8125Z",
    fill: "#470F17"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 33.4388H14.6309V35.8134H17.0055V33.4388Z",
    fill: "#96050A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 31.0641H14.6309V33.4387H17.0055V31.0641Z",
    fill: "#F20000"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 28.6896H14.6309V31.0642H17.0055V28.6896Z",
    fill: "#F20000"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 26.3149H14.6309V28.6895H17.0055V26.3149Z",
    fill: "#F20000"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 23.9403H14.6309V26.3149H17.0055V23.9403Z",
    fill: "#F20000"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 21.5581H14.6309V23.9403H17.0055V21.5581Z",
    fill: "#F20000"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 19.1835H14.6309V21.5581H17.0055V19.1835Z",
    fill: "#F20000"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 16.8088H14.6309V19.1834H17.0055V16.8088Z",
    fill: "#F20000"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 14.4343H14.6309V16.8089H17.0055V14.4343Z",
    fill: "#F20000"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 12.0597H14.6309V14.4343H17.0055V12.0597Z",
    fill: "#BD0304"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 9.68591H14.6309V12.0605H17.0055V9.68591Z",
    fill: "#470F17"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0055 2.56201H14.6309V4.93662H17.0055V2.56201Z",
    fill: "#470F17"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 35.8125H12.2476V38.1871H14.6298V35.8125Z",
    fill: "#470F17"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 33.4388H12.2476V35.8134H14.6298V33.4388Z",
    fill: "#96050A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 31.0641H12.2476V33.4387H14.6298V31.0641Z",
    fill: "#F20000"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 28.6896H12.2476V31.0642H14.6298V28.6896Z",
    fill: "#F20000"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 26.3149H12.2476V28.6895H14.6298V26.3149Z",
    fill: "#F20000"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 23.9403H12.2476V26.3149H14.6298V23.9403Z",
    fill: "#F20000"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 21.5581H12.2476V23.9403H14.6298V21.5581Z",
    fill: "#F20000"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 19.1835H12.2476V21.5581H14.6298V19.1835Z",
    fill: "#F20000"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 16.8088H12.2476V19.1834H14.6298V16.8088Z",
    fill: "#F20000"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 14.4343H12.2476V16.8089H14.6298V14.4343Z",
    fill: "#F20000"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 12.0597H12.2476V14.4343H14.6298V12.0597Z",
    fill: "#F20000"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 9.68591H12.2476V12.0605H14.6298V9.68591Z",
    fill: "#BD0304"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6298 7.31128H12.2476V9.68589H14.6298V7.31128Z",
    fill: "#470F17"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 33.4388H9.87378V35.8134H12.2484V33.4388Z",
    fill: "#470F17"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 31.0641H9.87378V33.4387H12.2484V31.0641Z",
    fill: "#F20000"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 28.6896H9.87378V31.0642H12.2484V28.6896Z",
    fill: "#F20000"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 26.3149H9.87378V28.6895H12.2484V26.3149Z",
    fill: "#F20000"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 23.9403H9.87378V26.3149H12.2484V23.9403Z",
    fill: "#F20000"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 21.5581H9.87378V23.9403H12.2484V21.5581Z",
    fill: "#F20000"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 19.1835H9.87378V21.5581H12.2484V19.1835Z",
    fill: "#F20000"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 16.8088H9.87378V19.1834H12.2484V16.8088Z",
    fill: "#F20000"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 14.4343H9.87378V16.8089H12.2484V14.4343Z",
    fill: "#F20000"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 12.0597H9.87378V14.4343H12.2484V12.0597Z",
    fill: "#F20000"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 9.68591H9.87378V12.0605H12.2484V9.68591Z",
    fill: "#F20000"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2484 7.31128H9.87378V9.68589H12.2484V7.31128Z",
    fill: "#470F17"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 33.4388H7.49878V35.8134H9.87339V33.4388Z",
    fill: "#470F17"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 31.0641H7.49878V33.4387H9.87339V31.0641Z",
    fill: "#BD0304"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 28.6896H7.49878V31.0642H9.87339V28.6896Z",
    fill: "#F20000"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 26.3149H7.49878V28.6895H9.87339V26.3149Z",
    fill: "#F20000"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 23.9403H7.49878V26.3149H9.87339V23.9403Z",
    fill: "#F20000"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 21.5581H7.49878V23.9403H9.87339V21.5581Z",
    fill: "#F20000"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 19.1835H7.49878V21.5581H9.87339V19.1835Z",
    fill: "#F20000"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 16.8088H7.49878V19.1834H9.87339V16.8088Z",
    fill: "#F20000"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 14.4343H7.49878V16.8089H9.87339V14.4343Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 12.0597H7.49878V14.4343H9.87339V12.0597Z",
    fill: "#F20000"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 9.68591H7.49878V12.0605H9.87339V9.68591Z",
    fill: "#F20000"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87339 7.31128H7.49878V9.68589H9.87339V7.31128Z",
    fill: "#470F17"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 31.0641H5.12378V33.4387H7.49839V31.0641Z",
    fill: "#470F17"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 28.6896H5.12378V31.0642H7.49839V28.6896Z",
    fill: "#BD0304"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 26.3149H5.12378V28.6895H7.49839V26.3149Z",
    fill: "#F20000"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 23.9403H5.12378V26.3149H7.49839V23.9403Z",
    fill: "#F20000"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 21.5581H5.12378V23.9403H7.49839V21.5581Z",
    fill: "#F20000"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 19.1835H5.12378V21.5581H7.49839V19.1835Z",
    fill: "#F20000"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 16.8088H5.12378V19.1834H7.49839V16.8088Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 14.4343H5.12378V16.8089H7.49839V14.4343Z",
    fill: "#F20000"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 12.0597H5.12378V14.4343H7.49839V12.0597Z",
    fill: "#F20000"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49839 9.68591H5.12378V12.0605H7.49839V9.68591Z",
    fill: "#470F17"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 28.6896H2.75V31.0642H5.12461V28.6896Z",
    fill: "#470F17"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 26.3149H2.75V28.6895H5.12461V26.3149Z",
    fill: "#470F17"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 23.9403H2.75V26.3149H5.12461V23.9403Z",
    fill: "#F20000"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 21.5581H2.75V23.9403H5.12461V21.5581Z",
    fill: "#F20000"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 19.1835H2.75V21.5581H5.12461V19.1835Z",
    fill: "#F20000"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 16.8088H2.75V19.1834H5.12461V16.8088Z",
    fill: "#F20000"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 14.4343H2.75V16.8089H5.12461V14.4343Z",
    fill: "#F20000"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12461 12.0597H2.75V14.4343H5.12461V12.0597Z",
    fill: "#470F17"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74961 23.9403H0.375V26.3149H2.74961V23.9403Z",
    fill: "#470F17"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74961 21.5581H0.375V23.9403H2.74961V21.5581Z",
    fill: "#470F17"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74961 19.1835H0.375V21.5581H2.74961V19.1835Z",
    fill: "#470F17"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74961 16.8088H0.375V19.1834H2.74961V16.8088Z",
    fill: "#470F17"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74961 14.4343H0.375V16.8089H2.74961V14.4343Z",
    fill: "#470F17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/IconApple.80f0f3c997f772a4fc01db77d039d4a5.svg";
export { ForwardRef as ReactComponent };